import { MockFactory } from '@tino-frontend/mocks'
import { BillListResponseV3, BillStatus } from '@types'
import { billBaseMock } from '@fixtures/apis/bill/detail-v3/bill-base'
import { lineItemProcessingPurchaseMock } from '../line-item/processing-purchase'

const bill0 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'bill-teste-OPEN',
    status: BillStatus.Open,
    line_item_groups: [
      { line_items: [lineItemProcessingPurchaseMock.source], is_paid: false },
    ],
  },
  { mergeArray: false }
)

export const billListOpenProcessingMock = new MockFactory<BillListResponseV3>({
  current_bill_id: 'bill-teste-OPEN',
  bills: [bill0],
})
